<a class="admin-button" [href]="link" target="_blank">
  <img [src]="icon" />
  {{ text }}
</a>
